import React, { FC } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { Pencil } from '@upstart/harmony/lib/legos/pencilTypes';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';

import Notes from './Notes';

type EmbeddedNotesProps = {
  deal: Deal;
  dealer: Dealer;
  isPencilsMutating?: boolean;
  pencilId: Pencil['id'];
  pencils: Pencil[];
  note: string;
  onPushToDMS: () => void;
  onShowRicTab: (e: Event) => void;
  onChange: (e: string) => void;
  onSubmit: () => void;
};

const EmbeddedNotes: FC<EmbeddedNotesProps> = props => {
  const {
    deal,
    dealer,
    note,
    pencilId,
    pencils,
    onChange,
    onShowRicTab,
    onPushToDMS,
    onSubmit,
    isPencilsMutating,
  } = props;

  const submitNote = () => {
    onSubmit();
  };

  if (isPencilsMutating) {
    return (
      <Dimmer active inverted>
        <Loader inverted content="Loading... Just a moment..." />
      </Dimmer>
    );
  }

  return (
    <div
      data-testid="embedded-notes"
      className="notes-modal-container v3-embedded"
    >
      <Notes
        isEmbeddedView
        pencils={pencils}
        note={note}
        deal={deal}
        onChange={onChange}
        dealer={dealer}
        pencilId={pencilId}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            submitNote();
          }
        }}
        showOfferAndRicTab={onShowRicTab}
        onPushToDMS={onPushToDMS}
      />
      <div className="notes-modal-footer">
        <button
          data-testid="notes-send-to-salesperson"
          className="notes-modal-button-save"
          onClick={() => submitNote()}
        >
          Send to Salesperson
        </button>
      </div>
    </div>
  );
};

export default EmbeddedNotes;
